import React, { Fragment, useEffect, useState } from 'react';
import Header from './general/Header';
import Footer from './general/Footer';
import Intro from './sections/Intro';
import Benefits from './sections/Benefits';
import Example from './sections/Example';
import Trial from './sections/Trial';
import Values from './sections/Values';
import Plan from './sections/Plan';
import Questions from './sections/Questions';
import Contact from './sections/Contact';
import Information from './sections/Information';
import MenuMobile from './sections/MenuMobile';
import PoweredBy from './general/PoweredBy';
import { useParams } from 'react-router-dom';

const getWidth = () =>
	window
		.getComputedStyle(document.querySelector('body'), ':before')
		.getPropertyValue('content')
		.replace(/"|'/g, '');

function Layout({ t }) {
	const [answerOpen, setAnswerOpen] = useState(0);
	const [menuOpen, setMenuOpen] = useState(false);
	const [width, setWidth] = useState(getWidth());
	const { language } = useParams();

	useEffect(() => {
		function handleResize() {
			setWidth(getWidth());
		}
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	function handleAnswerToggle(e, index) {
		if (typeof e.key === 'undefined' || e.key === 'Enter') {
			setAnswerOpen(answerOpen === index ? 0 : index);
		}
	}

	function handleMenuToggle(e) {
		if (typeof e.key === 'undefined' || e.key === 'Enter') {
			setMenuOpen((prev) => !prev);
		}
	}

	const benefits = t('landing.benefits.data', { returnObjects: true });
	const values = t('landing.values.data', { returnObjects: true });
	const plans = t('landing.plans.data', { returnObjects: true });
	const questions = t('landing.questions.data', { returnObjects: true });

	return (
		<Fragment>
			{width === 'phone' && menuOpen && (
				<MenuMobile
					t={t}
					menuOpen={menuOpen}
					handleMenuToggle={handleMenuToggle}
					language={language}
				/>
			)}
			<Header
				t={t}
				language={language}
				menuOpen={menuOpen}
				benefits={benefits}
				width={width}
				handleMenuToggle={handleMenuToggle}
			/>
			<Intro t={t} language={language} />
			<Benefits t={t} benefits={benefits} />
			<Example t={t} language={language} />
			<Trial t={t} language={language} />
			<Values t={t} values={values} />
			<Plan t={t} plans={plans} language={language} />
			<Questions
				t={t}
				questions={questions}
				answerOpen={answerOpen}
				handleAnswerToggle={handleAnswerToggle}
			/>
			<Contact t={t} width={width} />
			<Information t={t} />
			<Footer t={t} language={language} />
			<PoweredBy language={language} />
		</Fragment>
	);
}

export default Layout;
